module.exports = __webpack_public_path__ + "static/media/txt_prn13.34b6e069.png";